<template>
  <div
    class="f-column"
    style="gap: 1rem"
  >
    <tr>
      <td class="icmttstrctr_item_name">{{ $t('solfigr.icm.pot_size') }}</td>
      <td class="icmttstrctr_item_val">
        {{ numFixedUnit(item.pot_size, 'bb') }}
      </td>
    </tr>

    <div
      class="d-flex"
      style="gap: 1rem"
    >
      <div
        v-for="plr in display_players"
        :key="plr.position"
      >
        <div class="weight_500 d-flex">
          <div
            class="mdi mr-1"
            :class="plr.position === 'OOP' ? 'mdi-account' : 'mdi-account-outline'"
            style="padding: 0 0.25rem 0 0"
          ></div>
          <div
            class="slfrssmr_sizeplayer_title_position"
            v-html="getPlayerHtmlPosition(plr.display_position)"
          ></div>
        </div>
        <table>
          <tr
            v-for="ii in plr.options"
            :key="ii.name"
          >
            <td class="icmttstrctr_item_name">
              {{ ii.name }}
            </td>
            <td
              class="clr-white icmttstrctr_item_val"
              style="word-break: break-all"
            >
              {{ ii.value }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import { getSolfigrFields } from '@/store/solfigr/solfigr_helpers'

export default {
  name: 'SolfigrIcmHandDetailsItem',
  mixins: [format_mix],
  props: {
    item: Object,
    players: Array,
    icmTournament: Object,
  },
  computed: {
    display_players() {
      const conf = getSolfigrFields()
      const hasInstantBounty = conf.bounty_instant.is_active(this.icmTournament.type)
      const hasTotalBounty = conf.bounty_total.is_active(this.icmTournament.type)
      return [
        {
          position: 'OOP',
          display_position: this.players.find(p => p.position === 'OOP').display_position,
          options: [
            {
              name: this.$t('solfigr.icm.stack'),
              value: this.item.stack_OOP,
            },
            hasInstantBounty && {
              name: this.$t('solfigr.icm.bounty_instant'),
              value: this.item.bounty_instant_OOP,
            },
            hasTotalBounty && {
              name: this.$t('solfigr.icm.bounty_total'),
              value: this.item.bounty_total_OOP,
            },
          ].filter(Boolean),
        },
        {
          position: 'IP',
          display_position: this.players.find(p => p.position === 'IP').display_position,
          options: [
            {
              name: this.$t('solfigr.icm.stack'),
              value: this.item.stack_IP,
            },
            hasInstantBounty && {
              name: this.$t('solfigr.icm.bounty_instant'),
              value: this.item.bounty_instant_IP,
            },
            hasTotalBounty && {
              name: this.$t('solfigr.icm.bounty_total'),
              value: this.item.bounty_total_IP,
            },
          ].filter(Boolean),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.icmttstrctr {
  &_item {
    display: flex;
    flex-direction: var(--icmttstrctr-item-flex-direction);
    gap: var(--icmttstrctr-item-gap);
    &_name {
      color: var(--clr-grey-2);
      padding: 0 1rem 0 0;
      vertical-align: top;
    }
    &_val {
      font-weight: 500;
      vertical-align: top;
    }
  }
}
</style>
